/** Account API — Faz 1.4 createApi factory ile yeniden yazıldı. Önce. */
import {createApi} from './_factory'
import type {AccountNs, CommonNs} from '@shared/types'
import type {UIPreferencesNs} from '@shared/types/ui-preferences.namespace'

const api = createApi('account')

export const AccountApi = {
  getAccount: () =>
    api.post<void, AccountNs.Account>('get-account'),
  updateProperties: (data: AccountNs.UpdateAccountPropertyRequest) =>
    api.post<AccountNs.UpdateAccountPropertyRequest, AccountNs.Account>('update-properties', data),
  changePrimaryEmail: (data: AccountNs.ChangePrimaryEmailRequest) =>
    api.post<AccountNs.ChangePrimaryEmailRequest, CommonNs.AnyResponse>('change-primary-email', data),
  changePassword: (data: AccountNs.ChangePasswordRequest) =>
    api.post<AccountNs.ChangePasswordRequest, CommonNs.AnyResponse>('change-password', data),
  getGeneralInfo: () =>
    api.post<void, AccountNs.GeneralInfo>('general-info'),
  updateGeneralInfo: (data: AccountNs.UpdateGeneralInfoRequest) =>
    api.post<AccountNs.UpdateGeneralInfoRequest, AccountNs.GeneralInfo>('update-general-info', data),
  deleteAccount: (data: AccountNs.DeleteAccountRequest) =>
    api.post<AccountNs.DeleteAccountRequest, CommonNs.AnyResponse>('delete-account-with-workspace', data),
  confirmDeleteAccount: (data: AccountNs.ConfirmDeleteAccountRequest) =>
    api.post<AccountNs.ConfirmDeleteAccountRequest, CommonNs.AnyResponse>('confirm-delete-account', data),
  updateUiPreferences: (data: UIPreferencesNs.UIPreferences) =>
    api.post<UIPreferencesNs.UIPreferences, UIPreferencesNs.UIPreferences>('update-preferences', data),
  getUiPreferences: () =>
    api.post<void, UIPreferencesNs.UIPreferences>('get-preferences'),
}
